export default "__VITE_ASSET__BIEAABNE__"